window.ProfileAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    /**
     * Loads the positions by category
     * @returns {*}
     */
    self.getBrandProfile = cacheService.cache(function (brandId) {
        var defer = $q.defer();
        var apiUrl = environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl + 'profile/brand/'+brandId, 'GET').then(function (res) {
            if (res && res.data && res.data.data && res.status == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    })[0];

});
